/* Scroll-linked brand rule and asynchronously mounted app presentation. */
(() => {
  const motion=matchMedia('(prefers-reduced-motion: reduce)');
  const titles=new Set(), picks=new WeakSet(), emptyStates=new WeakSet();
  let frame=0, initFrame=0;
  function selectPick(pool){
    const products=[...pool.querySelectorAll('[data-vnk-mega-pick]')];
    const selected=Math.floor(Math.random()*products.length);
    products.forEach((product,index)=>product.hidden=index!==selected);
    return products.length;
  }
  function preparePicks(pool){
    if(picks.has(pool))return;picks.add(pool);
    if(selectPick(pool)||!pool.dataset.vnkProductsUrl)return;
    const menu=pool.closest('[data-vnk-bags-menu]');if(!menu)return;
    let started=false;
    const expandPool=async()=>{
      if(started)return;started=true;
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),5000);
      try{
        const url=new URL(pool.dataset.vnkProductsUrl,location.origin);
        if(url.origin!==location.origin)return;
        const response=await fetch(url,{credentials:'same-origin',signal:controller.signal});
        if(!response.ok)return;
        const parsed=new DOMParser().parseFromString(await response.text(),'text/html');
        const source=parsed.querySelector('[data-vnk-mega-picks]');
        if(!pool.isConnected||!source?.querySelector('[data-vnk-mega-pick]'))return;
        const products=[...source.querySelectorAll('[data-vnk-mega-pick]')];
        pool.replaceChildren(...products);selectPick(pool);
      }catch{/* Keep the usable collection link when no eligible product is available. */}
      finally{clearTimeout(timer);}
    };
    setTimeout(expandPool,150);
    menu.addEventListener('pointerenter',expandPool,{once:true});
    menu.addEventListener('focusin',expandPool,{once:true});
  }
  function updateScroll(){
    frame=0;
    titles.forEach(title=>{
      if(!title.isConnected){titles.delete(title);return;}
      const bounds=title.getBoundingClientRect(),top=bounds.top;
      const brandProgress=Math.max(0,Math.min(1,(innerHeight-top)/(innerHeight+bounds.height)));
      title.style.setProperty('--vnk-brand-progress',brandProgress.toFixed(3));
      const progress=motion.matches?1:Math.max(0,Math.min(1,(innerHeight*.88-top)/(innerHeight*.8)));
      title.style.setProperty('--vnk-scroll-ink',progress.toFixed(4));
    });
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(updateScroll);}
  function init(){
    initFrame=0;
    document.querySelectorAll('.vnk-polished-home .announcement__text h2,.vnk-polished-home .announcement__text .body-size-1').forEach(title=>{
      if(title.textContent.trim()!=='Stöbere nach Marke'||title.querySelector('h2'))return;
      title.classList.add('vnk-brand-scroll-title','vnk-section-reveal-title');titles.add(title);
    });
    document.querySelectorAll('[data-vnk-mega-picks]').forEach(pool=>{
      preparePicks(pool);
    });
    document.querySelectorAll('xb-wishlist-button-collection [title]').forEach(element=>element.removeAttribute('title'));
    document.querySelectorAll('xb-wishlist-page .xb-wishlist-products__no-product-desc > div').forEach(element=>{
      if(emptyStates.has(element)||!element.textContent.trim().startsWith('Ups, deine Wunschliste'))return;
      emptyStates.add(element);
      const first=element.firstChild;
      if(first?.nodeType!==Node.TEXT_NODE)return;
      const end=first.textContent.indexOf('!');if(end<0)return;
      first.textContent=first.textContent.slice(end+1).trimStart();
      const heading=document.createElement('p');heading.className='vnk-wishlist-empty-title';heading.textContent='Platz für deine Lieblingsstücke.';
      element.before(heading);
    });
    schedule();
  }
  function start(){
    init();
    new MutationObserver(records=>{
      if(!initFrame&&records.some(record=>record.addedNodes.length))initFrame=requestAnimationFrame(init);
    }).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule,{passive:true});
  motion.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load',init);
})();
